import axios from "axios";
import {
  GET_CARTOONS_FILTER,
  GET_FILTERED_CARTOONS,
  CLEAR_FILTERED_CARTOONS,
  GET_CARTOON,
  GET_CARTOON_EPISODES,
  GET_CARTOON_THREAD,
  CLEAR_CARTOON_DATA,
  GET_NEW_CARTOONS,
  GET_LAST_CARTOONS,
  GET_TOP_CARTOONS,
  GET_RECOMMENDED_CARTOONS,
} from "../constants";

export const getCartoonsFilterSuccess = (response) => ({
  type: GET_CARTOONS_FILTER,
  response,
});

export const getCartoonsFilter = () => (dispatch) =>
  axios
    .get("/videos/cartoons/filter")
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getCartoonsFilterSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getCartoonsFilterSuccess(data));
    });

export const getFilteredCartoonsSuccess = (response) => ({
  type: GET_FILTERED_CARTOONS,
  response,
});

export const getFilteredCartoons =
  (page = 1, genre = "", country = "", year = "", language = "") =>
  (dispatch) =>
    axios
      .get(
        `/videos/cartoons?page=${page}&size=12&genre=${genre}&country=${country}&year=${year}&language=${language}`
      )
      .then((response) => {
        const data = {
          status: response.status,
          pageLoaded: page,
          hasNext: response.data.pages !== 0 && response.data.pages !== page,
          data: response.data.data,
        };
        return dispatch(getFilteredCartoonsSuccess(data));
      })
      .catch((error) => {
        const data = {
          status: 0,
          data: [],
        };
        if (error.response) {
          data.status = error.response.status;
        } else if (error.request) {
          data.status = 0;
        } else {
          data.status = 0;
        }
        dispatch(getFilteredCartoonsSuccess(data));
      });

export const clearFilteredCartoons = () => ({
  type: CLEAR_FILTERED_CARTOONS,
});

export const clearCartoonData = () => ({
  type: CLEAR_CARTOON_DATA,
});

export const getCartoonThreadSuccess = (response) => ({
  type: GET_CARTOON_THREAD,
  response,
});

export const getCartoonThread = (id) => (dispatch) =>
  axios
    .get(`/videos/media/thread/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getCartoonThreadSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: (error.response && error.response.data) || [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getCartoonThreadSuccess(data));
    });

export const getCartoonEpisodesSuccess = (response) => ({
  type: GET_CARTOON_EPISODES,
  response,
});

export const getCartoonEpisodes = (id) => (dispatch) =>
  axios
    .get(`/videos/cartoon/episodes/${id}?size=100`)
    .then((response) => {
      const result = response.data.data.reverse();

      dispatch(getCartoonThread(result[0].id));
      const data = {
        status: response.status,
        data: result,
      };
      return dispatch(getCartoonEpisodesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getCartoonEpisodesSuccess(data));
    });

export const getCartoonSuccess = (response) => ({
  type: GET_CARTOON,
  response,
});

export const getCartoon = (id) => (dispatch) =>
  axios
    .get(`/videos/cartoon/${id}`)
    .then((response) => {
      dispatch(getCartoonEpisodes(response.data.data.seasons[0].id));
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getCartoonSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getCartoonSuccess(data));
    });

export const getNewCartoonsSuccess = (response) => ({
  type: GET_NEW_CARTOONS,
  response,
});

export const getNewCartoons =
  (page = 1, size = 15) =>
  (dispatch) =>
    axios
      .get(`/videos/cartoons?order=new&page=${page}&size=${size}`)
      .then((response) => {
        const data = {
          status: response.status,
          pageLoaded: page,
          hasNext: response.data.pages !== page,
          data: response.data.data,
        };
        return dispatch(getNewCartoonsSuccess(data));
      })
      .catch((error) => {
        const data = {
          status: 0,
          data: [],
        };
        if (error.response) {
          data.status = error.response.status;
        } else if (error.request) {
          data.status = 0;
        } else {
          data.status = 0;
        }
        dispatch(getNewCartoonsSuccess(data));
      });

export const getLastCartoonsSuccess = (response) => ({
  type: GET_LAST_CARTOONS,
  response,
});

export const getLastCartoons =
  (page = 1, size = 15) =>
  (dispatch) =>
    axios
      .get(`/videos/cartoons?order=last&page=${page}&size=${size}`)
      .then((response) => {
        const data = {
          status: response.status,
          pageLoaded: page,
          hasNext: response.data.pages !== page,
          data: response.data.data,
        };
        return dispatch(getLastCartoonsSuccess(data));
      })
      .catch((error) => {
        const data = {
          status: 0,
          data: [],
        };
        if (error.response) {
          data.status = error.response.status;
        } else if (error.request) {
          data.status = 0;
        } else {
          data.status = 0;
        }
        dispatch(getLastCartoonsSuccess(data));
      });

export const getTopCartoonsSuccess = (response) => ({
  type: GET_TOP_CARTOONS,
  response,
});

export const getTopCartoons =
  (page = 1, size = 15) =>
  (dispatch) =>
    axios
      .get(`/videos/cartoons?order=top&page=${page}&size=${size}`)
      .then((response) => {
        const data = {
          status: response.status,
          pageLoaded: page,
          hasNext: response.data.pages !== page,
          data: response.data.data,
        };
        return dispatch(getTopCartoonsSuccess(data));
      })
      .catch((error) => {
        const data = {
          status: 0,
          data: [],
        };
        if (error.response) {
          data.status = error.response.status;
        } else if (error.request) {
          data.status = 0;
        } else {
          data.status = 0;
        }
        dispatch(getTopCartoonsSuccess(data));
      });

export const getRecommendedCartoonsSuccess = (response) => ({
  type: GET_RECOMMENDED_CARTOONS,
  response,
});

export const getRecommendedCartoons =
  (page = 1, size = 15) =>
  (dispatch) =>
    axios
      .get(`/videos/cartoons?order=recommend&page=${page}&size=${size}`)
      .then((response) => {
        const data = {
          status: response.status,
          pageLoaded: page,
          hasNext: response.data.pages !== page,
          data: response.data.data,
        };
        return dispatch(getRecommendedCartoonsSuccess(data));
      })
      .catch((error) => {
        const data = {
          status: 0,
          data: [],
        };
        if (error.response) {
          data.status = error.response.status;
        } else if (error.request) {
          data.status = 0;
        } else {
          data.status = 0;
        }
        dispatch(getRecommendedCartoonsSuccess(data));
      });
